import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Param } from './param';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class ParamService {

    private api_url = `${environment.ApiUrl}/param`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<Param[]>(this.api_url);
    }

    save(param: Param) {
        return this.http.post<Param>(this.api_url, param, httpOptions);
    }

    update(param: Param) {
        return this.http.put<Param>(this.api_url, param, httpOptions);
    }

    delete(param: Param) {
        const url = `${this.api_url}/${param.id}`;
        return this.http.delete(url, httpOptions);
    }

    findActive() {
        return this.http.get<Param>(`${this.api_url}/active`);
    }
}